import { render, staticRenderFns } from "./RewardsTab.vue?vue&type=template&id=a0e16c14&"
import script from "./RewardsTab.vue?vue&type=script&lang=ts&"
export * from "./RewardsTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports